<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="$router.push('/oilTankCost/add')">新增</el-button>
        <el-button type="primary" @click="showExportDialog">导出超期费</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="仓库名称" prop="ygId">
          <el-select v-model="searchForm.ygId" :filterable="true" clearable placeholder="请选择仓库名称">
            <el-option v-for="(item, index) of ygList" :value="item.warehouseName" :label="item.warehouseName"
              :key="index"></el-option>
          </el-select> </el-form-item>
        <el-form-item prop="costType" label="费用类型">
          <el-select v-model="searchForm.costType" clearable filterable placeholder="请选择费用类型">
            <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ygDate" label="费用发生日期">
          <el-date-picker v-model="searchForm.ygDate" placeholder="请选择费用发生日期" type="date" clearable format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="userId" label="费用发生人">
          <el-select v-model="searchForm.userId" :filterable="true" clearable placeholder="请选择费用发生人">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="仓库名称" prop="ygCode"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="费用发生日期" prop="ygDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="费用发生人" prop="userName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="单价(元)" prop="unitPrice"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="数量(吨)" prop="ygNumber"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="130" label="总价(元)" prop="allPrice"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" label="费用类型 " prop="costType">
          <template v-slot="{ row }">
            {{ costTypeListMap.get(row.costType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" label="绩效" prop="jxPrice"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="110" label="关联发票" prop="invoiceId">
          <template v-slot="{ row }">
            <span class="btn" v-if="row.invoiceId"
              @click="$router.push('/system/newInvoice/detail?invoiceId=' + row.invoiceId)">
              发票详情
            </span>
            <span v-else>暂无发票</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/oilTankCost/edit?id=' + row.id)">编辑</el-button>
            <el-button type="text" @click="$router.push('/oilTankCost/detail?id=' + row.id)">详情</el-button>
            <el-button v-if="row.costType === '1'" type="text" @click="onDownPDF(row.id)">导出</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="超期费" class="global-dialog" :visible.sync="exportVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="exportForm" :rules="exportRules"
          ref="exportform" label-width="130px">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="startDate" label="时间范围">
                <el-date-picker v-model="dateArr" @change="onDateChange" start-placeholder="请选择开始日期"
                  end-placeholder="请选择结束日期" type="daterange" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="specId" label="品种规格">
                <el-select v-model="exportForm.specId" :filterable="true" clearable placeholder="请选择品种规格">
                  <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="userId" label="客户">
                <el-select v-model="exportForm.userId" :filterable="true" :clearable="true">
                  <el-option :label="item.userName" :value="item.userId" v-for="item in userList"
                    :key="item.userId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDownPDF2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { costTypeList } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'oilTankCost',
  mixins: [keepAlive],
  data() {
    return {
      costTypeListMap: costTypeList,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        ygId: null,
        ygDate: null,
        costType: null,
        userId: null
      },
      dateArr: [],
      exportForm: {
        startDate: '',
        endDate: '',
        specId: '',
        userId: ''
      },
      exportRules: {
        startDate: [{ required: true, message: '请选择时间范围' }],
        endDate: [{ required: true, message: '请选择时间范围' }],
        specId: [{ required: true, message: '请选择品种规格' }],
        userId: [{ required: true, message: '请选择客户' }]
      },
      typeArr: [
        // 1初始合同费用2存储费用3运费
        {
          label: '仓储费',
          value: '1'
        },
        {
          label: '超期费',
          value: '2'
        },
        {
          label: '货转费',
          value: '3'
        }
      ],
      ygList: [],
      userList: [],
      specList: [],
      exportVisible: false
    }
  },
  created() {
    this.loadDict()
    this.loadData()
  },
  methods: {
    onDateChange(val) {
      if (val.length) {
        this.exportForm.startDate = val[0]
        this.exportForm.endDate = val[1]
      } else {
        this.exportForm.startDate = ''
        this.exportForm.endDate = ''
      }
    },
    loadSpecList() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list || []
      })
    },
    showExportDialog() {
      this.exportVisible = true
      this.dateArr = []
      this.$nextTick(() => {
        this.$refs.exportform.resetFields()
      })
      this.loadSpecList()
    },
    onDownPDF2() {
      this.$refs.exportform.validate().then(() => {
        const loadingInstance = this.$loading({
          text: '正在导出...',
          background: 'rgba(0, 0, 0, 0.8)'
        })
        this.$axios.post(this.$apis.oilTankCost.txCqfPdf, this.exportForm, {
          responseType: 'blob'
        }).then(res => {
          if (res) {
            const contentDisposition = res.headers['content-disposition']
            let fileName = '超期费费用清单.pdf'

            if (contentDisposition) {
              // 匹配 filename="xxx.pdf"
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
              if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
              }
            }
            // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
            console.log('fileName', fileName)
            this.downloadFile(res.data, fileName)
          }
        }).catch(error => {
          console.error('导出失败:', error)
        }).finally(() => {
          loadingInstance.close()
        })
      })
    },
    onDownPDF(id) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.oilTankCost.txZqfPdf, {
        id: id
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '费用清单.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      console.log('decodeURIComponent(fileName)', decodeURIComponent(fileName))
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.oilTankCost.selectYgCostByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadDict() {
      // 油罐
      // this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
      //   this.ygList = res.list || []
      // })
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.ygList = res.list.map(item => {
          return {
            warehouseId: item.warehouseId,
            warehouseName: item.warehouseName
          }
        })
      })
      //   this.$axios.get(this.$apis.common.selectDicByList, {
      //     params: { dicType: 'ygType' }
      //   }).then(res => {
      //     this.dicList = res.ygType || []
      //   })

      // 用户
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        ygId: null,
        ygDate: null,
        costType: null,
        userId: null
      }
      this.onSearch()
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
